


















import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { UserInfo } from "../../_models/userInfo";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import * as auth from "../../_store/auth.module";

@Component
export default class DynamicMenu extends Vue {
  private items: object;
  private token: string;
  private userData: UserInfo;
  // private listItems: object;
  // private nodeList: object;

  constructor() {
    super();
    this.items = [];
    this.token = "";
    this.userData = {
      tipoSoggetto: 0,
      ruoloUtente: [],
      descrizioneRuolo: [],
      nomeUtente: "",
      cognomeUtente: "",
      indirizzoUtente: "",
      telefono1Utente: "",
      telefono2Utente: "",
      cod: "",
      dataNascita: "",
      luogoNascita: "",
      emailUtente: "",
      pecUtente: "",
      comuneUtente: "",
      provinciaUtente: "",
      entità: "",
      codEntità: 0,
      idCap: 0,
      idUtente: 0,
      cap: "",
      username: ""
    };
  }

  parseToken(token: string): JSON {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }
  created() {
    bus.$on("loadMenu", () => {
      var localToken: string | null = localStorage.getItem("userToken");
      // if (localToken !== null) {
      //   this.token = localToken.substring(1, localToken.length - 1);
      // }
      var parsedToken: any;
      if (localToken !== null) {
        parsedToken = this.parseToken(localToken);
      }
      var tokenInfo = {
        idUtente: parsedToken.IdUtente,
        tipoSoggetto: parsedToken.IdTipoSoggetto,
        username: parsedToken.Username
      };
      if (tokenInfo.tipoSoggetto === 4) {
        this.userData = user.readStudentInfo(this["$store"]);
      } else {
        this.userData = user.readUserInfo(this["$store"]);
      }
      var url =
        // "http://localhost:8181/RestApi/valtis/valtis/GetMenu?Utente=" + tokenInfo.username;

        "https://valtis.infosys.it/RestApi/valtis/valtis/GetMenu?Utente=" + tokenInfo.username;





        // "http://localhost:8181/GetMenu?IdRuolo=" + this.userData.ruoloUtente;
      // var url =
      // "https://valtis.infosys.it/RestApi/valtis/valtis/GetMenu?IdRuolo=" + this.userData.ruoloUtente;

      axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + localToken
          }
        })
        .then(response => {
          var listItems = populateList(response.data);

          var nodeList = internalToJSon(listItems);
          this.items = nodeList;
          bus.$emit("stopLoading");
        })
        .catch(error => {
          bus.$emit("stopLoading");
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
      // var token = localStorage.getItem("userToken");
      // var parsedToken: any;
      // if (token !== null) {
      //   parsedToken = this.parseToken(token);
      // }

      // var payload = {
      //   idUtente: parsedToken.IdUtente,
      //   tipoSoggetto: parsedToken.IdTipoSoggetto,
      //   username: parsedToken.Username
      // };

      // user.dispatchSetUserInfo(this["$store"], payload).then(() => {
      //   var check: string | null = localStorage.getItem("userToken");
      //   if (check !== null) {
      //     this.token = check.substring(1, check.length - 1);
      //   }
      //   this.userData = user.readUserInfo(this["$store"]);

      //   var url =
      //     "http://127.0.0.1:8022/GetMenu?IdRuolo=" + this.userData.ruoloUtente;
      //   axios
      //     .get(url, {
      //       headers: {
      //         Authorization: "Bearer " + this.token
      //       }
      //     })
      //     .then(response => {
      //       this.items = response.data;
      //     })
      //     .catch(error => {
      //       bus.$emit("errorOperation", error);
      //     });
      // });
    });

    function populateList(reourcesArray: any) {
      var listItems = [];
      var item = {
        Id: 0,
        name: "",
        IdPadre: 0,
        component: "",
        Ordine: 0,
        icon: "",
        Livello: 0,
        Path: ""
      };
      var i = 0;
      while (reourcesArray[i]) {
        item = {
          Id: reourcesArray[i].Id,
          name: reourcesArray[i].name,
          IdPadre: reourcesArray[i].IdPadre,
          component: reourcesArray[i].component,
          Ordine: reourcesArray[i].Ordine,
          icon: reourcesArray[i].icon,
          Livello: reourcesArray[i].Livello,
          Path: reourcesArray[i].Path
        };
        listItems[i] = searchSubItemsList(reourcesArray, item);
        i++;
      }
      return listItems;
    }

    function searchSubItemsList(arrayList: any, item: any) {
      var array: any = [];
      var completeItem = {
        Id: item.Id,
        name: item.name,
        IdPadre: item.IdPadre,
        component: item.component,
        Ordine: item.Ordine,
        icon: item.icon,
        Livello: item.Livello,
        Path: item.Path,
        children: array
      };
      var i = 0;
      while (arrayList[i]) {
        if (arrayList[i].IdPadre == completeItem.Id) {
          completeItem.children.push(arrayList[i].Id);
        }
        i++;
      }
      i = 0;
      return completeItem;
    }

    function internalToJSon(itemsList: any) {
      var list = [];
      var j = 0;
      var childrenArray = [];
      var nodeMap = new Map();
      for (j = itemsList.length - 1; j >= 0; j--) {
        if (itemsList[j].children.length == 0) {
          nodeMap.set(itemsList[j].Id, itemsList[j]);
        } else {
          var i;
          var childId;
          var child;
          for (i = 0; i < itemsList[j].children.length; i++) {
            childId = itemsList[j].children[i];
            child = nodeMap.get(childId);
            childrenArray.push(child);
          }
          itemsList[j].children = childrenArray;
          childrenArray = [];
          nodeMap.set(itemsList[j].Id, itemsList[j]);
        }
        if (itemsList[j].Livello == 1) {
          list.push(itemsList[j]);
        }
      }
      list.reverse();
      return list;
    }
  }
}
